module.exports = __webpack_public_path__ + "static/media/two_session_triangle.cba4db89.svg";